export default __webpack_public_path__ + "static/media/call_made_24px.bb251580.svg";